// Deep clone utility to create a new object/array
function deepClone(obj: any): any {
	if (obj === null || typeof obj !== 'object') {
		return obj;
	}

	// Special handling for built-in object types
	if (obj instanceof Blob || obj instanceof Date || obj instanceof RegExp || obj instanceof File) {
		return obj;
	}

	if (Array.isArray(obj)) {
		return obj.map(deepClone);
	}

	const clonedObj: { [key: string]: any } = {};
	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			clonedObj[key] = deepClone(obj[key]);
		}
	}

	return clonedObj;
}

// Merge function for deep merging objects
function merge(target: any, ...sources: any) {
	// If no sources, return a clone of the target
	if (sources.length === 0) {
		return deepClone(target);
	}

	// Create a deep clone of the target
	const result = deepClone(target);

	// Iterate through all source objects
	for (const source of sources) {
		if (source == null) continue;

		// Recursively merge each key
		for (const key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				const sourceValue = source[key];
				const targetValue = result[key];

				// If both are objects, do a deep merge
				if (
					sourceValue &&
					targetValue &&
					typeof sourceValue === 'object' &&
					typeof targetValue === 'object' &&
					!Array.isArray(sourceValue) &&
					!Array.isArray(targetValue)
				) {
					result[key] = merge(targetValue, sourceValue);
				}
				// For arrays, replace entirely
				else if (Array.isArray(sourceValue)) {
					result[key] = deepClone(sourceValue);
				}
				// For other types, overwrite
				else {
					result[key] = deepClone(sourceValue);
				}
			}
		}
	}

	return result;
}

// Export the functions for use
export { merge };
